import { useQuery } from '@tanstack/react-query';
import { get } from 'api/base';
import type { AnamnesisRecord, RawAnamnesisRecord } from 'types/anamnesis';
import { toAnamnesisRecord } from 'utils/anamnesis';
import { ANAMNESIS_LOOKUP_RETRIES, ANAMNESIS_LOOKUP_RETRY_DELAY_MS } from './anamnesisLookupPolicy';

async function fetchAnamnesisByPatientId(patientId: string): Promise<AnamnesisRecord> {
  const response = (await get('getAnamneses', undefined, {
    medatixxId: patientId,
  })) as RawAnamnesisRecord;

  return toAnamnesisRecord(response);
}

export const anamnesisLookupKeys = {
  byPatientId: (medatixxPatientId: string | undefined) =>
    ['anamnesisLookup', medatixxPatientId] as const,
};

export function useAnamnesisLookup(medatixxPatientId: string | undefined) {
  return useQuery<AnamnesisRecord, Error>({
    queryKey: anamnesisLookupKeys.byPatientId(medatixxPatientId),
    queryFn: () => fetchAnamnesisByPatientId(medatixxPatientId as string),
    enabled: !!medatixxPatientId,
    retry: ANAMNESIS_LOOKUP_RETRIES,
    retryDelay: ANAMNESIS_LOOKUP_RETRY_DELAY_MS,
  });
}
